import React from 'react';
import {BoxTeacher} from "./box/box-teacher/box-teacher";
import {BoxStudent} from "./box/box-teacher/box-student";
import {useAppSelector} from "common/hook";
import {ROLE_DEMO_STUDENT, ROLE_HR, ROLE_STUDENT, ROLE_TEACHER} from "entities/constants/constants";


const profileBoxComponents = {
    [ROLE_TEACHER]: <BoxTeacher />,
    [ROLE_HR]: <BoxTeacher />,
    [ROLE_STUDENT]: <BoxStudent />,
    [ROLE_DEMO_STUDENT]: <BoxStudent />,
};

export const ProfileBox = () => {
    const roleType = useAppSelector((state) => state.role.roleType);

    const profileBoxComponent = roleType ? profileBoxComponents[roleType] : null;

    return (
        <div>
            {profileBoxComponent}
        </div>
    );
};

